import { useEffect } from 'react';

// reducers
import { useSelector, useStore } from 'react-redux';
import { selectDistribution, updateDistribution } from 'hyc-store/reducers/distribution';
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// pipes
import { DisplayDate } from "shared/pipes/display-date";

// functions
import { useToggle } from 'shared/functions';

// components
import { ModalList } from './modal-list';
import { Button } from 'shared/components/bulma/button';

import * as helper from '../helper';

const ShipmentListTile = () => {
    const store = useStore();
    const { today, partners } = useSelector(selectDistribution);
    const country = useSelector(selectCountry);

    const [modal, setModal] = useToggle(false);
    const handleClick = () => {
        window.open('/shipment-lists', '_blank');
    }

    useEffect(() => {
        const getPartners = async (country) => {
            if (!partners) {
                const result = await helper.getPartners(country);
                store.dispatch(updateDistribution({ partners: result }));
            }
        }
        getPartners(country);

    }, [country, partners, store]);

    return (
        <section className="section is-small p-0 m-0">

            <div className="tile is-ancestor">

                <div className="tile">
                    <div className="tile is-parent is-vertical">
                        <article className="tile is-primary is-light is-12 is-child notification">
                            <div className="mb-3">
                                <div className="columns">

                                    <div className="column is-10">
                                        <p className="title">Shipment Lists</p>
                                        <div className="columns">
                                            <p>
                                                Today is: <DisplayDate>
                                                    {today}
                                                </DisplayDate>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="column is-2">
                                        <p><strong><Button onClick={setModal} className="is-primary m-2">Create New Shipment List</Button></strong></p>
                                        <p><strong><Button onClick={handleClick} className="is-secondary m-2">Go to Shipment Lists Page</Button></strong></p>

                                    </div>

                                </div>
                            </div>

                        </article>

                    </div>

                </div>
            </div >

            {/* Shipment Modal */}
            <ModalList modal={modal} handleModal={setModal} />
        </section>
    )

}

export { ShipmentListTile };
